import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ 
  message = 'Loading...', 
  currDarkThemeClass = '', 
  height = '300px',
  thickness = 5,
  size = 30,
  className = '',
  sx = {}
}) => (
  <Box 
    display="flex" 
    justifyContent="center" 
    alignItems="center" 
    height={height} 
    width="100%"
    className={className}
    sx={sx}
  >
    <CircularProgress thickness={thickness} size={size} />
    <Typography
      variant="h6"
      component="div"
      sx={{ ml: 2, color: 'white' }}
      className={currDarkThemeClass}
    >
      {message}
    </Typography>
  </Box>
);

export default LoadingSpinner;
